import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import ImportPage from "./ImportPage";
var Import = function () {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.SUPERUSER] },
                React.createElement(ImportPage, null))); } })));
};
export default Import;
